import ContentPanel, { BackpackThemedContentPanelWithFullHeader, DashboardThemedContentPanel, GroupThemedContentPanel, GroupThemedContentPanelWithFullHeader } from './ContentPanel';
import ContentPanelIframe from './ContentPanelIframe.presenter';
import ContentPanelFooter from './ContentPanelFooter';

export {
  ContentPanelIframe,
  ContentPanelFooter,
  DashboardThemedContentPanel,
  GroupThemedContentPanel,
  GroupThemedContentPanelWithFullHeader,
  BackpackThemedContentPanelWithFullHeader,
};

export default ContentPanel;
